<div class="dialog-header" cdkDrag cdkDragRootElement=".cdk-overlay-pane">
  <div class="header-side"></div>
  <div class="dialog-title-text" cdkDragHandle>
    @if (task === 'Edit') {
    {{ task }} {{screenName}} Load ({{ workOrderNumber }})
    } @else {
    {{ task }} {{screenName}} Load
    }
  </div>
  <button mat-icon-button class="close-btn" (click)="onCancel()">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content>
  
  <form class="form-grid">
    <input type="hidden" [(ngModel)]="id" name="id" />
    <input type="hidden" [(ngModel)]="taskId" name="taskId" />
    <input type="hidden" [(ngModel)]="stid" name="stid" />
    <input type="hidden" [(ngModel)]="siteTypeId" name="siteTypeId" />
   
    <div class="form-grid-row">
      <app-select-search (selectedItemId)="onMarketReceived($event)" [selectItems]="selectMarketItems"
        selectTitle = "Market" [setId]="marketId" [disabled]="ctrlpermissions.market"></app-select-search>
    </div>
    @if(scheduleId == 1){
      <div class="form-grid-row">
        <app-datetime-picker-input label="Date Received" [disabled]="ctrlpermissions.actualDate" [(ngModel)]="actualDate" name="actualDate" #adctrl="ngModel"
          required [use24Hour]="true" (selectedDate)="onDateReceivedChangedEvent($event)">
        </app-datetime-picker-input>
      </div>
    }
    @else{
      <div class="form-grid-row">
        <app-datetime-picker-input label="Pickup Date (If Drop-off Date is different)" [(ngModel)]="scheduleDate" name="scheduleDate" #sdctrl="ngModel"
          required [use24Hour]="true" [disabled]="ctrlpermissions.pickupDate">
        </app-datetime-picker-input>
        
        <app-datetime-picker-input label="Date Received" [(ngModel)]="actualDate" name="actualDate" #adctrl="ngModel"
          required [use24Hour]="true" [disabled]="ctrlpermissions.actualDate">
        </app-datetime-picker-input>
      </div>
    }
    <!-- Row 2: Generator dropdown and Stream dropdown -->
    <div class="form-grid-row">
      <app-select-search (selectedItemId)="onCustomerReceived($event)"  [selectItems]="selectCustomerItems" selectTitle = "Customer" [setId]="generatorId" [isrequired]="true"
        [matcher]="matcher" [invalid]="!!(!generatorId && attemptSave())" [disabled]="ctrlpermissions.customer"></app-select-search>

      <app-select-search (selectedItemId)="onStreamReceived($event)"  [selectItems]="selectStreamItems" selectTitle = "Stream" [setId]="streamId" [isrequired]="true"
        [matcher]="matcher" [invalid]="!!(!streamId && attemptSave())" [disabled]="ctrlpermissions.stream"></app-select-search>
    </div>

    <!-- Row 3: Disposal Site dropdown and Hauler dropdown -->
    <div class="form-grid-row">
      <app-select-search (selectedItemId)="onSiteReceived($event)" [disabled]="ctrlpermissions.site" [selectItems]="selectSiteItems" selectTitle = "Site" [setId]="disposalSiteId" [isrequired]="true"
        [matcher]="matcher" [invalid]="!!(!disposalSiteId && attemptSave())"></app-select-search>
      <app-select-search (selectedItemId)="onHaulerReceived($event)"  [selectItems]="selectHaulerItems" selectTitle = "Hauler"
        [setId]="haulerId" [isrequired]="true" [matcher]="matcher" [disabled]="ctrlpermissions.hauler" [invalid]="!!(attemptSave() && !haulerId)"></app-select-search>
    </div>

    @if(scheduleId == 1){
      <!-- Row 4: Tank dropdown and UOM dropdown -->
      <div class="form-grid-row"> 
        <mat-form-field appearance="outline">
          <mat-label>Tank</mat-label>
          <mat-select [(ngModel)]="tankId" data-testid="tankId" name="tankId" [disabled]="ctrlpermissions.tank"
            #tankCtrl="ngModel" [required]="isTankRequired" [errorStateMatcher]="matcher">
            <mat-option [value]="null">-Select Tank-</mat-option>
            @for (tank of tanks; track tank.tankID) {
              <mat-option [value]="tank.tankID">{{ tank.tankName }}</mat-option>
            }
          </mat-select>
          @if (isTankRequired && !tankId && (tankCtrl.touched || attemptSave())) {
            <mat-error>Tank is required</mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>UOM</mat-label>
          <mat-select [(ngModel)]="uomId" data-testid="uomId" name="uomId" [disabled]="ctrlpermissions.uom" required
            [errorStateMatcher]="matcher">
            <mat-option [value]="null">-Select UOM-</mat-option>
            @for (uom of uoms; track uom.id) {
            <mat-option [value]="uom.id">{{ uom.name }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>

      <!-- Row 5: Projected Quantity textbox and Fee category -->
      <div class="form-grid-row">
        <mat-form-field appearance="outline">
          <mat-label>Projected Quantity</mat-label>
          <input matInput type="text" data-testid="projectedVolume" [(ngModel)]="projectedVolume" [disabled]="(ctrlpermissions.projectedQuantity === true || (projectedVolume !== null && projectedVolume < 0))"
                name="projectedVolume" [min]="projectedQuantityMin" step="0.0001" max="999999"
                (keydown)="preventArrowKeyChange($event)" (input)="roundOff($event, 999999, 4, 2)"/>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Fee Category</mat-label>
          <mat-select [(ngModel)]="feeCategoryIds" data-testid="feeCategoryId" name="feeCategoryId"
            multiple [disabled]="ctrlpermissions.feeCategory" (selectionChange)="onFeeCategoriesChange(feeCategoryIds, true)">
            <div class="mat-select-search-container" (click)="$event.stopPropagation()">
              <input #siteSearchInput matInput placeholder="Search Customer..." (input)="filterFeeCats($event)"
                      class="mat-select-search-input" aria-label="Search Customer" (click)="$event.stopPropagation()"
                      (keydown)="$event.stopPropagation();" />
              <mat-icon class="mat-select-search-icon">search</mat-icon>
            </div>
            @for (category of filteredFeeCategories; track category.id) {
              <mat-option [value]="category.id">{{ category.category }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>

      <!-- Row 6: Tip Fee textbox and Flat Fee -->
      <div class="form-grid-row">
        <mat-form-field appearance="outline">
          <mat-label>Tip Fee</mat-label>
          <input matInput data-testid="tipFee" type="number" [(ngModel)]="tipFee" name="tipFee" [disabled]="true" />
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Flat Fee</mat-label>
          <input matInput type="text" id="flatFee" data-testid="flatFee" [(ngModel)]="flatFee"
            name="flatFee" max="9999.9999" step="0.0001" 
            [disabled]="isFlatFeeDisabled === true? true : ctrlpermissions.flatFee" (input)="roundOff($event, 9999, 4, 1)" />
        </mat-form-field>
      </div>

      <!-- Row 6a: Haul Fee textbox and hauling expense -->
      <div class="form-grid-row">
        <mat-form-field appearance="outline">
          <mat-label>Haul Revenue</mat-label>
          <input matInput data-testid="haulRevenue" type="number" [(ngModel)]="haulRevenue" name="haulRevenue" [disabled]="true" />
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Hauling Expense</mat-label>
          <input matInput type="text" id="haulingExpense" data-testid="haulingExpense" [(ngModel)]="haulingExpense"
            name="haulingExpense" [disabled]="ctrlpermissions.haulingExpense" (input)="roundOff($event, 9999, 2, 9)" />
        </mat-form-field>
      </div>

      <!-- Row 7: Status dropdown and Actual Quantity textbox -->
      <div class="form-grid-row">
        <mat-form-field appearance="outline">
          <mat-label>Status</mat-label>
          <mat-select [(ngModel)]="statusId" name="statusId"
            (selectionChange)="onStatusChange($event.value, true)"
            (opened)="onStatusDropdownOpened()" [disabled]="ctrlpermissions.status">
            <mat-option [value]="null">-Select Status-</mat-option>
            @for (status of fsStatusList; track status.id) {
            <mat-option [value]="status.id" [disabled]="status.description === 'Invoiced'">{{ status.description }}</mat-option>
            }
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Actual Volume</mat-label>
          <input matInput type="text" [(ngModel)]="actualQuantity" name="actualQuantity"
            (keydown)="preventArrowKeyChange($event)" step="0.0001" max="999999" [disabled]="ctrlpermissions.actualVolume"
            (input)="roundOff($event, 999999, 4, 3)"/>
        </mat-form-field>
      </div>

      <!-- Row 8: Driver's Name textbox and Load Slip Number textbox -->
      <div class="form-grid-row">
        <mat-form-field appearance="outline">
          <mat-label>Driver's Name</mat-label>
          <input matInput type="text" maxlength="50" [disabled]="ctrlpermissions.driverName" data-testid="driverName" [(ngModel)]="driverName" name="driverName" />
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Load Slip Number</mat-label>
          <input matInput type="text" maxlength="10" [disabled]="ctrlpermissions.loadSlipNumber" data-testid="loadSlipNumber"
            [(ngModel)]="loadSlipNumber" name="loadSlipNumber" (input)="roundOff($event, 99999999, 0, 5)" />
        </mat-form-field>
      </div>

      @if (showCancelRow) {
        <div class="form-grid-row">
          <mat-form-field appearance="outline">
            <mat-label>Cancel Reason</mat-label>
            <mat-select [(ngModel)]="cancelReasonId" name="cancelReasonId" data-testid="cancelReasonId"
              #cancelReasonCtrl="ngModel" required [errorStateMatcher]="matcher" [disabled]="ctrlpermissions.cancelReason">
              <mat-option [value]="null">- Select Reason -</mat-option>
              @for (reason of cancelReasons; track trackById(reason.id, reason)) {
                <mat-option [value]="reason.id">{{ reason.name }}</mat-option>
              }
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Notes for Cancel Reason</mat-label>
            <textarea matInput maxlength="250" [(ngModel)]="cancelReasonNotes" [disabled]="ctrlpermissions.cancelReasonNotes"
              data-testid="cancelReasonNotes" name="cancelReasonNotes" rows="1"></textarea>
          </mat-form-field>
        </div>
      }

      <!-- Row 8: truck no textbox and customer reference textbox -->
      <div class="form-grid-row">
        <mat-form-field appearance="outline">
          <mat-label>Customer Reference Number</mat-label>
          <input matInput type="text" maxlength="25" [(ngModel)]="customerReferenceNo"
            [disabled]="ctrlpermissions.customerReferenceNo" name="customerReferenceNo" />
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Truck Number</mat-label>
          <input matInput type="text"  maxlength="25" [(ngModel)]="truck_Number"
            [disabled]="ctrlpermissions.truckNumber" name="truckNumber" />
        </mat-form-field>
      </div>

      <!-- Row 10: Trailer Number textbox and notes fo hauler textbox -->
      <div class="form-grid-row trailer-hauler-row">
        <mat-form-field appearance="outline">
          <mat-label>Trailer Number</mat-label>
          <input matInput type="text"  maxlength="25" [(ngModel)]="trailerNumber" [disabled]="ctrlpermissions.trailerNumber" name="trailerNumber" />
        </mat-form-field>

        <mat-form-field appearance="outline" class="flex-50 large">
          <mat-label>Notes For Hauler</mat-label>
          <textarea matInput data-testid="notesForHauler" maxlength="1000" [disabled]="ctrlpermissions.notesForHauler"
            [(ngModel)]="notesForHauler" name="notesForHauler" rows="1"></textarea>
        </mat-form-field>
      </div>

      <!-- Row 11: Internal Notes textarea and internal site haul cost -->
      <div class="form-grid-row" style="position: relative;">
        @if(showNotesPopupLink){
          <div (click)="openInternalNotesPopup()" 
              style="position: absolute;top: 0;left: 0;width: 44%;height: 100%;z-index: 10;cursor: pointer;"
              title="Click to add Load Notes">
          </div>    
          <mat-form-field appearance="outline" class="flex-50 large">
            <mat-label>Load Notes(For internal purpose only)</mat-label>
            <textarea matInput data-testid="internalNotes" maxlength="3000"
              [(ngModel)]="internalNotes" name="internalNotes" rows="3"></textarea>
          </mat-form-field>
        }
        @else{
          <mat-form-field appearance="outline" class="flex-50 large">
            <mat-label>Load Notes(For internal purpose only)</mat-label>
            <textarea matInput data-testid="internalNotes" maxlength="3000" [disabled]="ctrlpermissions.internalNotes"
              [(ngModel)]="internalNotes" name="internalNotes" rows="1"></textarea>
          </mat-form-field>
        }

        <mat-form-field appearance="outline" class="flex-50 large">
          <mat-label>Internal Site Haul Cost Reason</mat-label>
          <mat-select [(ngModel)]="internalSiteHaulCostReasonId" data-testid="internalSiteHaulCostReasonId"
              name="internalSiteHaulCostReasonId"
              [disabled]="internalSiteHaulCostReasonIdDisabled === true? true : ctrlpermissions.internalSiteHaulCostReason"
              [required]="!internalSiteHaulCostReasonIdDisabled" [errorStateMatcher]="matcher">
            <div class="mat-select-search-container" (click)="$event.stopPropagation()">
              <input #internalSiteHaulCostReasonSearchInput matInput placeholder="Search ..." (input)="filterInternalSiteHaulCostReasons($event)"
                class="mat-select-search-input" aria-label="Search " (keydown)="$event.stopPropagation();" />
              <mat-icon class="mat-select-search-icon">search</mat-icon>
            </div>
            @for (market of filteredInternalSiteHaulCostReasons; track market.id) {
            <mat-option [value]="market.id">{{ market.name }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>

      <!-- Row 12: Notes for Customer textarea and COD Notes textarea -->
      <div class="form-grid-row">
        <mat-form-field appearance="outline" class="flex-50 large">
          <mat-label>Notes For Customer</mat-label>
          <textarea matInput data-testid="notesForCustomer" maxlength="500" [(ngModel)]="notesForCustomer"
            [disabled]="ctrlpermissions.notesForCustomer" name="notesForCustomer" rows="3"></textarea>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>COD Notes</mat-label>
          <textarea matInput data-testid="codNotes" maxlength="2000" [(ngModel)]="codNotes" name="codNotes"
            [disabled]="ctrlpermissions.codNotes" rows="3"></textarea>
        </mat-form-field>
      </div>

      <!-- Row 13: seal & bol -->
      <div class="form-grid-row">
        <mat-form-field appearance="outline">
          <mat-label>BOL #</mat-label>
          <input matInput type="text" [(ngModel)]="bol" [disabled]="ctrlpermissions.bol" name="bol" maxlength="15"/>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Seal #</mat-label>
          <input matInput type="text" [(ngModel)]="seal" [disabled]="ctrlpermissions.seal" name="seal" maxlength="15"/>
        </mat-form-field>
      </div>

      <!-- Row 14: hold load & Invoice this load -->
      <div class="form-grid-row">
        <mat-slide-toggle data-testid="holdLoadOnComplete" name="holdLoadOnComplete"
          [(ngModel)]="holdLoadOnComplete" [disabled]="ctrlpermissions.holdLoadOnComplete"
          color="primary"
          labelPosition="before" class="flex-50 large">
          <span class="font-medium text-gray-700 w-44 inline-block">Hold Load On Complete:</span>
        </mat-slide-toggle>

        <mat-slide-toggle data-testid="isInvoiceReqForCancelledLoad" name="isInvoiceReqForCancelledLoad"
          [(ngModel)]="isInvoiceReqForCancelledLoad"
          color="primary"
          labelPosition="before" class="flex-50 large"
          [disabled]="ctrlpermissions.invoiceThisLoad == true? true : isInvoiceReqForCancelledLoadDisabled">
          <span class="font-medium text-gray-700 w-44 inline-block">Invoice This Load:</span>
        </mat-slide-toggle>
      </div>

      <!-- Row 15: diverted load & sc workorder no -->
      <div class="form-grid-row">
        <mat-slide-toggle data-testid="divertedLoad" name="divertedLoad"
          [(ngModel)]="divertedLoad" [disabled]="ctrlpermissions.divertedLoad"
          color="primary"
          labelPosition="before" class="flex-50 large">
          <span class="font-medium text-gray-700 w-44 inline-block">Diverted Load:</span>
        </mat-slide-toggle>

        <!-- <mat-form-field appearance="outline">
          <mat-label>SC Workorder #</mat-label>
          <input matInput type="text" name="scWorkOrder" [(ngModel)]="scWorkOrder" [disabled]="disableSCWorkOrder" maxlength="15" />
        </mat-form-field>         -->
      </div>
    }
    @else{
      <!-- Row 4: Flat Fee textbox and Fee Category dropdown -->
      <div class="form-grid-row">
        <mat-form-field appearance="outline">
          <mat-label>Fee Category</mat-label>
          <mat-select [(ngModel)]="feeCategoryId" data-testid="feeCategoryId"
            [disabled]="ctrlpermissions.feeCategory" name="feeCategoryId" (selectionChange)="onFeeCategoryChange($event.value)">
            <div class="mat-select-search-container" (click)="$event.stopPropagation()">
              <input #siteSearchInput matInput placeholder="Search Customer..." (input)="filterSFeeCategory($event)"
                      class="mat-select-search-input" aria-label="Search Customer" (click)="$event.stopPropagation()"
                      (keydown)="$event.stopPropagation();" />
              <mat-icon class="mat-select-search-icon">search</mat-icon>
            </div>
            <mat-option [value]="null">-Select Fee Category-</mat-option>
            @for (category of filteredFeeCategories; track category.id) {
            <mat-option [value]="category.id">{{ category.category }}</mat-option>
            }
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Flat Fee</mat-label>
          <input matInput type="text" id="flatFee" data-testid="flatFee" [(ngModel)]="flatFee" name="flatFee"
            [disabled]="isFlatFeeDisabled === true? true : ctrlpermissions.flatFee"
            (input)="roundOff($event, 99999, 4, 1)" />
        </mat-form-field>
      </div>

      <!-- Row 5: UOM and Status dropdown -->
      <div class="form-grid-row">
        <mat-form-field appearance="outline">
          <mat-label>UOM</mat-label>
          <mat-select [(ngModel)]="uomId" data-testid="uomId" name="uomId" disabled>
            <mat-option [value]="null">-Select UOM-</mat-option>
            @for (uom of uoms; track uom.id + '-' + uom.name){
            <mat-option [value]="uom.id">{{ uom.name }}</mat-option>
            }
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Status</mat-label>
          <mat-select [(ngModel)]="statusId" data-testid="statusId" name="statusId"
            (selectionChange)="onStatusChange($event.value, true)"
            (opened)="onStatusDropdownOpened()" [disabled]="ctrlpermissions.status">
            <mat-option [value]="null">-Select Status-</mat-option>
            @for (status of fsStatusList; track status.id) {
            <mat-option [value]="status.id" [disabled]="status.description === 'Invoiced'">{{ status.description }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>

      @if (showCancelRow) {
        <div class="form-grid-row">
          <mat-form-field appearance="outline">
            <mat-label>Cancel Reason</mat-label>
            <mat-select [(ngModel)]="cancelReasonId" name="cancelReasonId" data-testid="cancelReasonId"
              [disabled]="ctrlpermissions.cancelReason"
              #cancelReasonCtrl="ngModel" [disabled]="ctrlpermissions.cancelReason" required [errorStateMatcher]="matcher">
              <mat-option [value]="null">- Select Reason -</mat-option>
              @for (reason of cancelReasons; track trackById(reason.id, reason)) {
                <mat-option [value]="reason.id">{{ reason.name }}</mat-option>
              }
            </mat-select>
            <mat-error>Cancel Reason is required</mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Notes for Cancel Reason</mat-label>
            <textarea matInput [(ngModel)]="cancelReasonNotes" [disabled]="ctrlpermissions.cancelReasonNotes"
              data-testid="cancelReasonNotes" name="cancelReasonNotes" rows="1"></textarea>
          </mat-form-field>
        </div>
      }

      <!-- Row 6: Tip Fee textbox and haul fee/load -->
      <div class="form-grid-row">
        <mat-form-field appearance="outline">
          <mat-label>Tip Fee</mat-label>
          <input matInput type="number" data-testid="tipFee" [(ngModel)]="tipFee" name="tipFee" disabled />
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Haul Fee/Load</mat-label>
          <input matInput type="number" data-testid="haulFee" [(ngModel)]="haulFee" name="haulFee" disabled />
        </mat-form-field>
      </div>

      <!-- Row 7: Projected Quantity, hauling expense textbox -->
      <div class="form-grid-row">
        <mat-form-field appearance="outline" class="form-field-item small flex-50">
          <mat-label>Projected Quantity</mat-label>
          <input matInput type="text" [(ngModel)]="projectedVolume"  [disabled]="ctrlpermissions.projectedQuantity"
            name="projectedVolume" min="0" step="0.0001" data-testid="projectedVolume" max="999999"
            (keydown)="preventArrowKeyChange($event)" (input)="roundOff($event, 999999, 4, 2)" />
        </mat-form-field>

        <mat-form-field appearance="outline" class="form-field-item small flex-50">
          <mat-label>Hauling Expense</mat-label>
          <input matInput type="text" id="haulingExpense" data-testid="haulingExpense" [(ngModel)]="haulingExpense"
            name="haulingExpense" [disabled]="ctrlpermissions.haulingExpense"
            (input)="roundOff($event, 9999, 2, 9)" />
        </mat-form-field>
      </div>

      <!-- Row 7a: actual quantity and tons textbox -->
      <div class="form-grid-row">
        <mat-form-field appearance="outline" class="form-field-item small flex-50">
          <mat-label>Actual Quantity</mat-label>
          <input matInput type="text" [(ngModel)]="actualQuantity" [disabled]="ctrlpermissions.actualQuantity == true? true : isActualQuantityDisabled"
            name="actualQuantity" data-testid="actualQuantity" min="0" step="0.0001" max="999999"
            (keydown)="preventArrowKeyChange($event)" (input)="roundOff($event, 999999, 4, 3)" />
        </mat-form-field>

        <mat-form-field appearance="outline" class="form-field-item small flex-50">
          <mat-label>Actual Tons</mat-label>
          <input matInput type="text" data-testid="actualTons" [(ngModel)]="actualTons" (ngModelChange)="onActualTonChange()"
            [disabled]="ctrlpermissions.actualTons == true ? true : isActualTonsEnabled"
            name="actualTons" min="0" step="0.0001" max="999999"
            (keydown)="preventArrowKeyChange($event)" (input)="roundOff($event, 999999, 4, 4)" />
        </mat-form-field>
      </div>

      <!-- Row 8: Rebate UOM and quantity -->
      <div class="form-row" style="margin-left: 9px;margin-top: 13px;">
        <mat-form-field appearance="outline" class="form-field-item small flex-50">
          <mat-label>Rebate UOM</mat-label>
          <mat-select [(ngModel)]="ruomId" data-testid="ruomId" name="ruomId" disabled="disabled">
            <mat-option [value]="null">-Select UOM-</mat-option>
            @for (ruom of ruoms; track ruom.id + '-' + ruom.name) {
            <mat-option [value]="ruom.id">{{ ruom.name }} </mat-option>
            }
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="form-field-item small flex-25">
          <mat-label>Rebate Quantity</mat-label>
          <input matInput type="text" data-testid="rebateQuantity" [(ngModel)]="rebateQuantity" [disabled]="isRebateDisabled"
            name="rebateQuantity" (input)="roundOff($event, 999999, 4, 6)" />
        </mat-form-field>

        <mat-form-field appearance="outline" class="form-field-item small flex-25">
          <mat-label>Rebate Amount</mat-label>
          <input matInput type="number" data-testid="rebateValue" [(ngModel)]="rebateValue" disabled="true"
            name="rebateValue" />
        </mat-form-field>
      </div>   

      <!-- Row 9: Driver's Name textbox and trailer and truck Number textbox -->
      <div class="form-row" style="margin-left: 9px;margin-top: 13px;">
        <mat-form-field appearance="outline" class="form-field-item small flex-50">
          <mat-label>Driver's Name</mat-label>
          <input matInput type="text" [disabled]="ctrlpermissions.driverName" maxlength="50" data-testid="driverName" [(ngModel)]="driverName" name="driverName" id="driverName" />
        </mat-form-field>

        <mat-form-field appearance="outline" class="form-field-item small flex-25">
          <mat-label>Trailer Number</mat-label>
          <input matInput type="text" data-testid="trailerNumber" maxlength="25" [disabled]="ctrlpermissions.trailerNumber" [(ngModel)]="trailerNumber" name="trailerNumber" />
        </mat-form-field>

        <mat-form-field appearance="outline" class="form-field-item small flex-25">
          <mat-label>Truck Number</mat-label>
          <input matInput type="text" data-testid="truckNumber" [disabled]="ctrlpermissions.truckNumber" maxlength="25" [(ngModel)]="truck_Number" name="truckNumber" />
        </mat-form-field>
      </div>

      @if(scheduleId == 2){
        <!-- Row 10: Disposal methods and customer ref -->
        <div class="form-grid-row" style="margin-top: 13px;">
          <mat-form-field appearance="outline">
            <mat-label>Disposal Method</mat-label>
            <mat-select [(ngModel)]="disposalMethodId" data-testid="disposalMethodId" name="disposalMethodId"
              [disabled]="ctrlpermissions.disposalMethod">
              <mat-option [value]="null">-Select Disposal Method-</mat-option>
              @for (dm of disposalMethods; track dm.id) {
                <mat-option [value]="dm.id">{{ dm.disposalMethod }}</mat-option>
              }
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Customer Ref. #</mat-label>
            <input matInput type="text" data-testid="customerReferenceNo"
              maxlength="25" [disabled]="ctrlpermissions.customerReferenceNo" [(ngModel)]="customerReferenceNo" name="customerReferenceNo" />
          </mat-form-field>
        </div>

        <!-- Row 11: load notes and customer notes -->
        <div class="form-grid-row">
          @if(showNotesPopupLink){
            <div (click)="openInternalNotesPopup()" 
                style="position: absolute;top: 0;left: 0;width: 44%;height: 100%;z-index: 10;cursor: pointer;"
                title="Click to add Load Notes">
            </div>
            <mat-form-field appearance="outline" class="flex-50 large">
              <mat-label>Load Notes(For internal purpose only)</mat-label>
              <textarea matInput data-testid="internalNotes" maxlength="3000" [(ngModel)]="internalNotes" name="internalNotes" rows="3"></textarea>
            </mat-form-field>
          }
          @else{
            <mat-form-field appearance="outline" class="flex-50 large">
              <mat-label>Load Notes(For internal purpose only)</mat-label>
              <textarea matInput data-testid="internalNotes" maxlength="3000" [disabled]="ctrlpermissions.internalNotes"
                [(ngModel)]="internalNotes" name="internalNotes" rows="3"></textarea>
            </mat-form-field>
          }

          <mat-form-field appearance="outline" class="flex-50 large">
            <mat-label>Notes for Customer</mat-label>
            <textarea matInput data-testid="notesForCustomer" maxlength="500" [disabled]="ctrlpermissions.notesForCustomer"
              [(ngModel)]="notesForCustomer" name="notesForCustomer" rows="3"></textarea>
          </mat-form-field>
        </div>

        <!-- Row 12:  Notes for Hauler textarea and COD notes textarea -->
        <div class="form-grid-row">
          <mat-form-field appearance="outline" class="flex-50 large">
            <mat-label>Notes for Hauler</mat-label>
            <textarea matInput maxlength="1000" [(ngModel)]="notesForHauler" [disabled]="ctrlpermissions.notesForHauler"
              data-testid="notesForHauler" name="notesForHauler" rows="3"></textarea>
          </mat-form-field>

          <mat-form-field appearance="outline" class="flex-50 large">
            <mat-label>COD Notes</mat-label>
            <textarea matInput maxlength="2000" [(ngModel)]="codNotes" [disabled]="ctrlpermissions.codNotes"
              data-testid="codNotes" name="codNotes" rows="3"></textarea>
          </mat-form-field>
        </div>
        
        <!-- Row 13: Seal and BOL -->
        <div class="form-grid-row">
          <mat-form-field appearance="outline">
            <mat-label>Seal #</mat-label>
            <input matInput type="text" [(ngModel)]="seal" [disabled]="ctrlpermissions.seal" name="seal" maxlength="15" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>BOL #</mat-label>
            <input matInput type="text" [(ngModel)]="bol" [disabled]="ctrlpermissions.bol" name="bol" maxlength="15" />
          </mat-form-field>
        </div>
        <!-- Row 14: sc workorder no -->
        <div class="form-grid-row">  
          <mat-form-field appearance="outline">
            <mat-label>SC Workorder #</mat-label>
            <input matInput type="text" name="scWorkOrder" [(ngModel)]="scWorkOrder"
              [disabled]="ctrlpermissions.scWorkOrder === true? true : disableSCWorkOrder" maxlength="15" (input)="roundOff($event, 999999999999999, 0, 10)" />
          </mat-form-field>        
        </div>

        <!-- Row 15: Invoice this load and hold load on complete and diverted load -->
        <div class="form-grid-row">
          <mat-slide-toggle data-testid="holdLoadOnComplete" name="holdLoadOnComplete"
            [(ngModel)]="holdLoadOnComplete" [disabled]="ctrlpermissions.holdLoadOnComplete"
            color="primary"
            labelPosition="before" class="flex-50 large">
            <span class="font-medium text-gray-700 w-44 inline-block">Hold Load on Complete:</span>
          </mat-slide-toggle>
        
          <mat-slide-toggle data-testid="isInvoiceReqForCancelledLoad" name="isInvoiceReqForCancelledLoad"
            [(ngModel)]="isInvoiceReqForCancelledLoad"
            color="primary"
            labelPosition="before" class="flex-50 large" [disabled]="ctrlpermissions.invoiceThisLoad == true ? true : isInvoiceReqForCancelledLoadDisabled">
            <span class="font-medium text-gray-700 w-44 inline-block">Invoice This Load:</span>
          </mat-slide-toggle>

          <mat-slide-toggle data-testid="divertedLoad" name="divertedLoad"
            [(ngModel)]="divertedLoad" [disabled]="ctrlpermissions.divertedLoad"
            color="primary"
            labelPosition="before" class="flex-50 large">
            <span class="font-medium text-gray-700 w-44 inline-block">Diverted Load:</span>
          </mat-slide-toggle>
        </div>
      }
      @else {
        <!-- Row 10: disposal methods and hold load on complete -->
        <div class="form-grid-row">
          <mat-form-field appearance="outline">
            <mat-label>Disposal Method</mat-label>
            <mat-select [(ngModel)]="disposalMethodId" data-testid="disposalMethodId" name="disposalMethodId"
              [disabled]="ctrlpermissions.disposalMethod">
              <mat-option [value]="null">-Select Disposal Method-</mat-option>
              @for (dm of disposalMethods; track dm.id) {
                <mat-option [value]="dm.id">{{ dm.disposalMethod }}</mat-option>
              }
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Customer Ref. #</mat-label>
            <input matInput type="text" data-testid="customerReferenceNo"
              [disabled]="ctrlpermissions.customerReferenceNo" [(ngModel)]="customerReferenceNo" name="customerReferenceNo" maxlength="25"/>
          </mat-form-field>
        </div>
        
        <!-- Row 11: truck type dropdown and load notes -->
        <div class="form-grid-row">
          <mat-form-field appearance="outline">
            <mat-label>Truck Type</mat-label>
            <mat-select [(ngModel)]="truckId" data-testid="truckId" name="truckId" [disabled]="ctrlpermissions.truckType">
              <mat-option [value]="null">-Select Truck Type-</mat-option>
              @for (truck of truckTypes; track truck.id) {
              <mat-option [value]="truck.id">{{ truck.truckType }}</mat-option>
              }
            </mat-select>
          </mat-form-field>

          @if(showNotesPopupLink){
            <div class="flex-50" style="position: relative; width: 100%">
              <div (click)="openInternalNotesPopup()" 
                  style="position: absolute;top: 0;left: 0;width: 100%;height: 17%;z-index: 10;cursor: pointer;"
                  title="Click to add Load Notes">
              </div>    
              <mat-form-field appearance="outline" class="large" style="width: 100% !important;">
                <mat-label class="underlined-label">Load Notes(For internal purpose only) Click here to edit</mat-label>
                <textarea matInput data-testid="schedulingNotes" maxlength="3000" [(ngModel)]="schedulingNotes" name="schedulingNotes" rows="3"></textarea>
              </mat-form-field>
            </div>
          }
          @else{
            <mat-form-field appearance="outline" class="flex-50 large">
              <mat-label>Load Notes(For internal purpose only)</mat-label>
              <textarea matInput data-testid="schedulingNotes" maxlength="3000" [(ngModel)]="schedulingNotes"
                name="schedulingNotes" rows="1" [disabled]="ctrlpermissions.internalNotes"></textarea>
            </mat-form-field>
          }
        </div>

        <!-- Row 12: customer Notes textarea and Notes for Hauler textarea -->
        <div class="form-grid-row">
          <mat-form-field appearance="outline" class="flex-50 large">
            <mat-label>Notes for Customer</mat-label>
            <textarea matInput maxlength="250" data-testid="ntesForCustomer" [disabled]="ctrlpermissions.notesForCustomer"
              [(ngModel)]="notesForCustomer" name="notesForCustomer" rows="3"></textarea>
          </mat-form-field>

          <mat-form-field appearance="outline" class="flex-50 large">
            <mat-label>Notes for Hauler</mat-label>
            <textarea matInput maxlength="250" data-testid="notesForHauler" [disabled]="ctrlpermissions.notesForHauler"
              [(ngModel)]="notesForHauler" name="notesForHauler" rows="3"></textarea>
          </mat-form-field>
        </div>

        <!-- Row 13: disposal sites Notes textarea and cod Notes textarea -->
        <div class="form-grid-row">
          <mat-form-field appearance="outline" class="flex-50 large">
            <mat-label>Notes for disposal sites</mat-label>
            <textarea matInput maxlength="250" data-testid="notesForDisposalSite" [disabled]="ctrlpermissions.notesForDisposalSite"
              [(ngModel)]="notesForDisposalSite" name="notesForDisposalSite" rows="3"></textarea>
          </mat-form-field>

          <mat-form-field appearance="outline" class="flex-50 large">
            <mat-label>COD Notes</mat-label>
            <textarea matInput maxlength="250" [(ngModel)]="codNotes" [disabled]="ctrlpermissions.codNotes"
              data-testid="codNotes" name="codNotes" rows="3"></textarea>
          </mat-form-field>
        </div>
          
        <!-- Row 13: Seal and BOL -->
        <div class="form-grid-row">
          <mat-form-field appearance="outline">
            <mat-label>Seal #</mat-label>
            <input matInput type="text" [(ngModel)]="seal" [disabled]="ctrlpermissions.seal" name="seal" maxlength="15" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>BOL #</mat-label>
            <input matInput type="text" [(ngModel)]="bol" [disabled]="ctrlpermissions.bol" name="bol" maxlength="15" />
          </mat-form-field>
        </div>

        <!-- Row 14: sc workorder no -->
        <div class="form-grid-row">  
          <mat-form-field appearance="outline">
            <mat-label>SC Workorder #</mat-label>
            <input matInput type="text" name="scWorkOrder" [(ngModel)]="scWorkOrder"
              [disabled]="ctrlpermissions.scWorkOrder === true ? true : disableSCWorkOrder" maxlength="15" (input)="roundOff($event, 999999999999999, 0, 10)" />
          </mat-form-field>        
        </div>

        <!-- Row 15: Invoice this load and hold load on complete and diverted load -->
        <div class="form-grid-row">
          <mat-slide-toggle data-testid="holdLoadOnComplete" name="holdLoadOnComplete"
            [(ngModel)]="holdLoadOnComplete" [disabled]="ctrlpermissions.holdLoadOnComplete"
            color="primary"
            labelPosition="before" class="flex-50 large">
            <span class="font-medium text-gray-700 w-44 inline-block">Hold Load on Complete:</span>
          </mat-slide-toggle>
        
          <mat-slide-toggle data-testid="isInvoiceReqForCancelledLoad" name="isInvoiceReqForCancelledLoad"
            [(ngModel)]="isInvoiceReqForCancelledLoad"
            color="primary" labelPosition="before" class="flex-50 large"
            [disabled]="ctrlpermissions.invoiceThisLoad == true ? true : isInvoiceReqForCancelledLoadDisabled">
            <span class="font-medium text-gray-700 w-44 inline-block">Invoice This Load:</span>
          </mat-slide-toggle>

          <mat-slide-toggle data-testid="divertedLoad" name="divertedLoad"
            [(ngModel)]="divertedLoad" [disabled]="ctrlpermissions.divertedLoad"
            color="primary"
            labelPosition="before" class="flex-50 large">
            <span class="font-medium text-gray-700 w-44 inline-block">Diverted Load:</span>
          </mat-slide-toggle>
        </div>
      }
    }
    <!-- Additional Streams Grid -->
    <div class="add-stream-button-container">
      @if(ctrlpermissions.addStreamButton){
        <button mat-raised-button color="primary" data-testid="btnaddStream" (click)="openAddorEditStreamDialog(0, null, false)">
          <mat-icon>add</mat-icon> Add Stream
        </button>
      }
    </div>
    <div class="mat-elevation-z2 viewport">
      <table mat-table [dataSource]="additionalStreamsDataSource">
        <ng-container matColumnDef="streamName">
          <th mat-header-cell *matHeaderCellDef> Stream Name </th>
          <td mat-cell *matCellDef="let element"> {{element.streamName}} </td>
        </ng-container>
        <ng-container matColumnDef="uom">
          <th mat-header-cell *matHeaderCellDef> UOM </th>
          <td mat-cell *matCellDef="let element"> {{element.uomText}} </td>
        </ng-container>
        <ng-container matColumnDef="quantity">
          <th mat-header-cell *matHeaderCellDef> Quantity </th>
          <td mat-cell *matCellDef="let element"> {{element.quantity}} </td>
        </ng-container>
        <ng-container matColumnDef="tipFee">
          <th mat-header-cell *matHeaderCellDef> Tip Fee </th>
          <td mat-cell *matCellDef="let element"> {{element.tipFee}} </td>
        </ng-container>
        <ng-container matColumnDef="aD_RebateUOMText">
          <th mat-header-cell *matHeaderCellDef> Rebate UOM </th>
          <td mat-cell *matCellDef="let element"> {{element.aD_RebateUOMText}} </td>
        </ng-container>
        <ng-container matColumnDef="aD_RebateQty">
          <th mat-header-cell *matHeaderCellDef> Rebate Qty </th>
          <td mat-cell *matCellDef="let element"> {{element.aD_RebateQty}} </td>
        </ng-container>
        <ng-container matColumnDef="rebateValue">
          <th mat-header-cell *matHeaderCellDef> Rebate Amount </th>
          <td mat-cell *matCellDef="let element"> {{element.rebateValue}} </td>
        </ng-container>
        <ng-container matColumnDef="tons">
          <th mat-header-cell *matHeaderCellDef> Actual Tons </th>
          <td mat-cell *matCellDef="let element"> {{element.tons}} </td>
        </ng-container>
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef> Actions</th>
          <td mat-cell *matCellDef="let row">
            <div style="margin-left: -13px;">
              @if(ctrlpermissions.editStreamButton){
                <button mat-icon-button type="button" class="icon-btn edit-icon" title="Edit" [disabled]="row.id === 0"
                (click)="openAddorEditStreamDialog(row.id, row, true)">
                  <mat-icon>edit</mat-icon>
                </button>
              }
              @if(ctrlpermissions.deleteStreamButton){
                <button mat-icon-button type="button" color="warn" title="Delete" style="color: red;"
                (click)="deleteAddtStreams(row)">
                  <mat-icon>delete</mat-icon>
                </button>
              }
            </div>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedAdditionalStreamColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedAdditionalStreamColumns;"></tr>
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" colspan="4">No additional streams found.</td>
        </tr>
      </table>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end" class="dialog-footer">
  @if(!disableSCWorkOrder){
    <button data-testid="btnRPC" mat-raised-button color="primary" mat-primary (click)="openRPC()">
      Add/View RPC
    </button>
  }
  @if(showDocsButtons){
    <button data-testid="btnAttach" mat-raised-button color="primary" mat-primary (click)="openAttachDocuments()">
      <mat-icon>attach_file_add</mat-icon>
      Attach Documents
    </button>
    <button data-testid="btnView" mat-raised-button color="primary" mat-primary (click)="openViewDocsDialog()">
      <mat-icon>visibility</mat-icon>
      View Documents
    </button>
  }
  @if (ctrlpermissions.saveButton) {
    <button data-testid="btnReset" mat-raised-button color="primary" mat-primary (click)="onReset()">
      Reset
    </button>
  }
  <button data-testid="btnCancel" mat-raised-button color="primary" mat-primary (click)="onClose()">
    Cancel
  </button>
  @if (ctrlpermissions.saveButton) {
    <button data-testid="btnSave" mat-raised-button color="primary" mat-primary (click)="onSave()">
      Save
    </button>
  }
</mat-dialog-actions>
